import { Box, Typography } from '@mui/material'
import type { TFormattedRequestData } from '@utils/requestFormatter'
import { sectionTitleSx, fieldLabelSx, fieldValueSx, compactFieldSx } from '../styles'

interface PublicationCardInfoProps {
  formattedData: TFormattedRequestData
}

const formatBoolValue = (value: string | boolean): string => {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }
  return value
}

const InfoRow = ({ label, value }: { label: string; value: string | boolean }) => (
  <Box sx={compactFieldSx}>
    <Typography sx={fieldLabelSx}>{label}</Typography>
    <Typography sx={fieldValueSx}>{formatBoolValue(value)}</Typography>
  </Box>
)

export const PublicationCardInfo = ({ formattedData }: PublicationCardInfoProps) => {
  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={sectionTitleSx}>Publication Details</Typography>
        <Box sx={{ borderRadius: 1, p: 1 }}>
          <InfoRow label="Request Type" value={formattedData.requestTypeName} />
          <InfoRow label="Publication Type" value={formattedData.publicationType} />
          <InfoRow label="Licensee" value={formattedData.licensee} />
          <InfoRow label="Publisher" value={formattedData.publisher} />
        </Box>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <Typography sx={sectionTitleSx}>Additional Information</Typography>
        <Box sx={{ borderRadius: 1, p: 1 }}>
          <InfoRow label="Arranger/Editor" value={formattedData.publicationAuthorArrangerEditor} />
          <InfoRow label="Distribution Method" value={formattedData.distributionMethod} />
          <InfoRow label="Distribution Territory" value={formattedData.distributionTerritory} />
          <InfoRow label="Publication Date" value={formattedData.plannedPublicationDate} />
          <InfoRow label="Reprint" value={formattedData.isReprint} />
          {formattedData.totalRetailPrice && (
            <InfoRow label="Total Retail Price" value={`$${formattedData.totalRetailPrice}`} />
          )}
        </Box>
      </Box>
    </>
  )
}
